<template>
	<div>
			<el-table
					:data="tableData"
					:summary-method="getSummaries"
					show-summary
			>
					<el-table-column label="Date" width="160">
						<template slot-scope="scope">
							<p v-if="scope.row.commitment_is_manual != 1" class="top-line text-break">{{
								scope.row.commitment_approved_date }}</p>
							<el-input v-else v-model="scope.row.commitment_approved_date" type="date"  :disabled="(_gHlp.checkAccess(['role_telemarketing']))" ></el-input>
						</template>
					</el-table-column>
					<el-table-column
							prop="commitment_lender_type"
							width="130px"
							label="Lender"
					>
							<template slot-scope="scope">
								<p v-if="scope.row.commitment_is_manual != 1" class="top-line text-break">{{
									scope.row.commitment_lender_type }}</p>
								<el-input v-else v-model="scope.row.commitment_lender_type"  :disabled="(_gHlp.checkAccess(['role_telemarketing']))" ></el-input>
							</template>
					</el-table-column>
					<el-table-column
							prop="commitment_loan_statue"
							width="140"
							label="Facility"
					>
							<template slot="header" slot-scope="scope">
									<span class="text-break">{{ scope.column.label }}</span>
							</template>
							<div slot-scope="scope" v-if="scope.row.commitment_is_manual">
									<el-select v-model="scope.row.commitment_loan_statue"  :disabled="(_gHlp.checkAccess(['role_telemarketing']))" >
											<el-option
											v-for="(item,index) in tables.loan_types"
											:key="index"
											:label="item.code"
											:value="item.code">
											</el-option>
									</el-select>
							</div>
							<div v-else>
									{{ scope.row.commitment_loan_statue }}
							</div>
					</el-table-column>
					<el-table-column
							prop="commitment_current_outstanding"
							sortable
							width="170px"
							:formatter="formatCurrency"
							label="Current Outstanding"
					>
							<template slot="header" slot-scope="scope">
									<span class="text-break">{{ scope.column.label }}</span>
							</template>
							<template slot-scope="scope">
									<el-input v-model="scope.row.commitment_current_outstanding"  :disabled="(_gHlp.checkAccess(['role_telemarketing']))" ></el-input>
							</template>
					</el-table-column>
					<el-table-column
							prop="commitment_current_installment"
							sortable
							width="160px"
							:formatter="formatCurrency"
							label="Current Instalment"
					>
							<template slot="header" slot-scope="scope">
									<span class="text-break">{{ scope.column.label }}</span>
							</template>
							<template slot-scope="scope">
									<el-input :disabled="(_gHlp.checkAccess(['role_telemarketing'])) || scope.row.commitment_is_consolidate" v-model="scope.row.commitment_current_installment"></el-input>
							</template>
					</el-table-column>
					<el-table-column
							prop="commitment_special_settlement"
							sortable
							width="160px"
							:formatter="formatCurrency"
							label="Special Settlement"
					>
							<template slot="header" slot-scope="scope">
									<span class="text-break">{{ scope.column.label }}</span>
							</template>
							<template slot-scope="scope">
									<el-input v-model="scope.row.commitment_special_settlement" :disabled="(_gHlp.checkAccess(['role_telemarketing']))"></el-input>
							</template>
					</el-table-column>
					<el-table-column
							prop="commitment_consolidate_settlement"
							sortable
							width="180px"
							:formatter="formatCurrency"
							label="Consolidate Settlement"
					>
							<template slot="header" slot-scope="scope">
									<span class="text-break">{{ scope.column.label }}</span>
							</template>
							<template slot-scope="scope">
									<el-input :disabled="(_gHlp.checkAccess(['role_telemarketing'])) || scope.row.commitment_is_consolidate"  v-model="scope.row.commitment_consolidate_settlement"></el-input>
							</template>
					</el-table-column>
					<el-table-column width="auto">
						<template slot-scope="scope">
							<el-switch v-model="scope.row.commitment_is_consolidate" active-color="#13ce66" @change="setConsolidate(scope.$index,scope.row)" :disabled="(_gHlp.checkAccess(['role_telemarketing']))"></el-switch>
						</template>
					</el-table-column>
					<el-table-column
							prop="commitment_new_installment"
							sortable
							width="180px"
							:formatter="formatCurrency"
							label="New Instalment"
             
					>
							<template slot="header" slot-scope="scope">
									<span class="text-break">{{ scope.column.label }}</span>
							</template>
							<template slot-scope="scope">
									<el-input v-model="scope.row.commitment_new_installment" :disabled="(_gHlp.checkAccess(['role_telemarketing']))"></el-input>
							</template>
					</el-table-column>
					<el-table-column label="Action">
							<template slot-scope="scope">
									<el-button 
											@click="deleteManualCommitment(scope.row.commitment_id,scope.$index)"
											type="danger" 
											icon="el-icon-close"
											size="mini" 
											circle
											class="p-0"
											v-if="scope.row.commitment_is_manual"
                      :disabled="(_gHlp.checkAccess(['role_telemarketing']))"
									></el-button>
							</template>
					</el-table-column>
			</el-table>
			<el-button type="text" @click="addCommitment" v-if="(!_gHlp.checkAccess(['role_telemarketing']))" >+ Add Commitment</el-button>
			<div class="mt-3">
					<b-row class="d-flex justify-content-center">
							<b-col cols="6" md="3">
									<el-button class="bg-primary text-white w-100" 
											@click="saveManualCommitment" 
											:loading="is_loading"
                      v-if="(!_gHlp.checkAccess(['role_telemarketing']))" 
									>Save
									</el-button>
							</b-col>
					</b-row>
			</div>
	</div>
</template>
<script>
import { Button, Table, TableColumn, Input, Select, Option, Switch } from 'element-ui'
import { mapState, mapActions } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'
import { useCreditReportStore } from '@/stores/creditReportStore'
import {
	helperFunctionMixin,
	notifyFunctionMixin,
	axios,
	services,
	getHeader,
} from '@/assets/js/httpImports.js'
import {isEqual} from 'lodash'
import solutionEventBus from '@/assets/js/EventBus/solutionEventBus.js'

export default {
	props: ['commitments', 'tables'],
	components: {
			[Switch.name]: Switch,
			[Button.name]: Button,
			[Table.name]: Table,
			[TableColumn.name]: TableColumn,
			[Input.name]: Input,
			[Select.name]: Select,
			[Option.name]: Option,
	},
	mixins: [helperFunctionMixin, notifyFunctionMixin],
	data() {
			return {
					modals:{
							show_full_view: false
					},
					is_loading: false,
					tableData: [],
					original_ctos_commitments:[],
					original_ctos_manual_commitments:[]
			}
	},
	computed:{
			 ...mapState(useCustomerStore, ['current_customer', 'current_commitment'])
	},
	watch: {
			current_commitment(newVal){
					if(newVal){
							this.setTable()
					}
			},
	},
	async created(){
			this.setTable()
	},
	methods: {
			...mapActions(useCustomerStore, ['generateDSR']),
			...mapActions(useCreditReportStore, ['getCreditReportSummary']),
			addCommitment(){
					this.tableData.push({
							"commitment_credit_report_id": this.current_commitment ? this.current_commitment.credit_report_id : null,
							"commitment_cust_id": this.current_customer.customer_id,
							"commitment_cust_ic": this.current_customer.nric ? this.current_customer.nric : this.current_customer.passport,
							"commitment_is_special_attention": 1,
							"commitment_capacity": null,
							"commitment_approved_date": null,
							"commitment_lender_type": null,
							"commitment_loan_statue": null,
							"commitment_bank_id": null,
							"commitment_legal_status": null,
							"commitment_legal_name": null,
							"commitment_legal_date": null,
							"commitment_col_type": null,
							"commitment_repay_term": null,
							"commitment_status": null,
							"commitment_credit_limit": 0,
							"commitment_current_outstanding": 0,
							"commitment_current_installment": 0,
							"commitment_special_settlement": 0,
							"commitment_consolidate_settlement": 0,
							"commitment_new_installment": 0,
							"commitment_date_balance_updated": null,
							"commitment_position_date": null,
							"commitment_json_month": [],
							"commitment_is_manual": 1
					})
			},
			saveManualCommitment(){
					var axiosCalls = []
					var manual_commitments = this.tableData.filter(item => item.commitment_is_manual === 1)
					var ctos_commitments = this.tableData.filter(item => item.commitment_is_manual !== 1)

					this.is_loading = true

					manual_commitments.forEach((commitment) => {
							if(commitment.hasOwnProperty('commitment_id')){
									// update existing manual commitment
									const original_ctos_manual_commitment = this.original_ctos_manual_commitments.find(item => item.commitment_id === commitment.commitment_id)
									if(!isEqual(original_ctos_manual_commitment, commitment)){
											axiosCalls.push(this.updateManualCommitment(commitment.commitment_id, commitment))
									}
							}else{
									// create new manual commitment
									axiosCalls.push(this.createManualCommitment(commitment))
							}
					})

					ctos_commitments.forEach((commitment) => {
							const original_ctos_commitment = this.original_ctos_commitments.find(item => item.commitment_id === commitment.commitment_id)
							if(!isEqual(original_ctos_commitment, commitment)){
									axiosCalls.push(this.updateManualCommitment(commitment.commitment_id, commitment))
							}
					})

					Promise.all(axiosCalls)
                .then(async (res)  => {
									this.notifySuccess('<b>Commitment </b> - Successfully Updated.')
									await this.getCreditReportSummary({credit_report_cust_id: this.current_customer.customer_id,recalculate_summary:true})
                  solutionEventBus.$emit('refresh-ctos');
									this.is_loading = false
							})
							.catch(e => {
									this.is_loading = false
									this.errorFunction(e)
							})
			},
			createManualCommitment(data){
					return axios.post(services.commitment +'manual-commitment', data, {headers: getHeader()});
			},
			updateManualCommitment(id, data){
					return axios.post(services.commitment +'manual-commitment/'+id, data, {headers: getHeader()});
			},
			deleteManualCommitment(id, index) {
					if(!id){
							this.tableData.splice(index, 1);
							return
					}

					axios.post(services.commitment +'manual-commitment/delete/'+id, null, {headers: getHeader()}).then(res  => {
									this.notifySuccess('<b>Commitment </b> - Successfully Deleted.')
									this.tableData.splice(index, 1);
									this.generateDSR()
							})
							.catch(e => {
									this.errorFunction(e, e.response.data.error)
							})
			},
			setTable(){
					this.tableData = []
					if(this.current_commitment){
							this.current_commitment.credit_report_summary.special_attensions.forEach(item => {

									if(item.commitment_is_manual === 0){
											item.commitment_sub_items.forEach(sub_item => {
													//MODIF FOR SWITCH ELEMENT
													sub_item.commitment_is_consolidate = sub_item.commitment_is_consolidate == 1 ? true : false;

													this.tableData.push(sub_item)
													this.original_ctos_commitments.push({...sub_item})
											});
									}else{
											//MODIF FOR SWITCH ELEMENT
											item.commitment_is_consolidate = item.commitment_is_consolidate == 1 ? true : false;
										
											this.tableData.push(item)
											this.original_ctos_manual_commitments.push({...item})
									}
							});
					}
			},
			setConsolidate(index,item){
				if(item.commitment_is_consolidate){
					item['commitment_consolidate_settlement_prev'] = item.commitment_consolidate_settlement;
					item['commitment_new_installment_prev'] = item.commitment_new_installment;

					item.commitment_consolidate_settlement = item.commitment_current_outstanding;
					item.commitment_new_installment = 0;
				}else{
					if(!_gHlp.isEmpty(item.commitment_consolidate_settlement_prev)){
						item.commitment_consolidate_settlement = item.commitment_consolidate_settlement_prev
					}
					if(!_gHlp.isEmpty(item.commitment_new_installment_prev)){
						item.commitment_new_installment = item.commitment_new_installment_prev
					}
				}
				this.tableData[index] = item;
			},
			getSummaries(param) {
					const { columns, data } = param;
					const sums = [];
					columns.forEach((column, index) => {
							if (index === 0) {
									sums[index] = 'Summary';
									return;
							}
							const values = data.map(item => Number(item[column.property]));
							if (!values.every(value => isNaN(value))) {
									const total = values.reduce((prev, curr) => {
											const value = Number(curr);
											if (!isNaN(value)) {
													return prev + curr;
											} else {
													return prev;
											}
									}, 0);

									sums[index] = 'RM ' + total.toLocaleString('en-MY', {minimumFractionDigits: 2});
									} else {
											sums[index] = '';
									}
					});

					return sums;
			},
			handleDelete(index) {
					this.tableData.splice(index, 1);
			},
			formatCurrency(row, column, cellValue) {
					return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'MYR' }).format(cellValue);
			},
			formatCurrencyCard(value) {
					return `MYR ${parseFloat(value).toLocaleString(undefined, {minimumFractionDigits: 2})}`;
			},
	}
}
</script>